module.exports = __webpack_public_path__ + "img/createMap.6eb97b2c.svg";